import React from 'react';
import { Image } from 'react-bootstrap';

import Bludot from 'src/assets/images/logo-blue.png';

type CardProps = {
  cardDetails: ActivationCard;
};

const Card: React.FunctionComponent<CardProps> = ({ cardDetails }) => {
  if (!cardDetails) {
    return null;
  }

  const { expiryMonth, expiryYear, cvv, zipCode } = cardDetails;

  return (
    <div className="position-relative my-3">
      <div className="position-absolute text-primary">
        <Image src={Bludot} height={64} className="mt-2" />
        <h4 className="my-3 ml-3 pt-2 font-weight-bold">
          {(cardDetails.number || '').match(/.{1,4}/g).map(n => (
            <span key={n} className="mr-3">
              {n}
            </span>
          ))}
        </h4>
        <div className="d-flex ml-3 pt-3">
          <span>
            <span className="small">VALID THRU</span> <br />
            {expiryMonth}/{expiryYear}
          </span>
          <span className="mx-3 px-4">
            <span className="small">CVV</span> <br />
            {cvv}
          </span>
          <span>
            <span className="small">ZIP CODE</span> <br />
            {zipCode}
          </span>
        </div>
      </div>
      <SvgComponent />
    </div>
  );
};

export default Card;

const SvgComponent = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={441} height={240} viewBox="0 0 441 240">
      <defs>
        <linearGradient id="prefix__a" x1={0.5} x2={0.5} y2={1} gradientUnits="objectBoundingBox">
          <stop offset={0} stopColor="#91c5f4" />
          <stop offset={1} stopColor="#fff" />
        </linearGradient>
        <clipPath id="prefix__b">
          <rect className="prefix__a" width={440} height={238} rx={6} />
        </clipPath>
        <style>{'.prefix__a{fill:url(#prefix__a)}'}</style>
      </defs>
      <g transform="translate(1)" fill="#fff" stroke="#e3e3e3" strokeWidth={1.4}>
        <rect width={440} height={240} rx={6} stroke="none" />
        <rect x={0.7} y={0.7} width={438.6} height={238.6} rx={5.3} fill="none" />
      </g>
      <g transform="translate(0 1)" clipPath="url(#prefix__b)">
        <ellipse className="prefix__a" cx={142} cy={142.5} rx={142} ry={142.5} transform="translate(262 -48)" />
      </g>
    </svg>
  );
};
